// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/password-input","toggleButton":"password-input-m__toggleButton__1j-cn button-m__nativeResetRoot__18WbL"};